import { MessageDescriptor } from 'react-intl';
import { camelize } from 'lib/utility';
import { formatIntlMessage } from './shared';
import { defaultMessages } from './default';

const getErrorLocale = (key: string): MessageDescriptor => {
  const intlMessage = formatIntlMessage(`errors ${key}`);

  return defaultMessages[camelize(intlMessage)];
};

export default getErrorLocale;
